import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';
import { formatDateBr } from '@core/utils/filter';
import SLSUnidadeMedidaService from '@/services/SistemaDKP/SLSUnidadeNegocio.service';
// Notification
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default function useUsersList(nameModule) {
  // Use toast
  const toast = useToast();
  const sLSUnidadeMedidaService = new SLSUnidadeMedidaService();
  const refUnidadeNegocioListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: 'unidade_negocio_id', label: 'Código', sortable: false },
    { key: 'unidade_negocio_descricao', label: 'Descrição', sortable: true },
    { key: 'actions', label: 'Ações', sortable: false },
  ];
  const perPage = ref(10);
  const totalItem = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref('');
  const sortBy = ref('unidade_negocio_id');
  const isSortDirDesc = ref(true);
  const overlay = ref(true);
  const statusFilter = ref(null);

  const dataMeta = computed(() => {
    const localItemsCount = refUnidadeNegocioListTable.value ? refUnidadeNegocioListTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalItem.value,
    };
  });

  const refetchData = () => {
    refUnidadeNegocioListTable.value.refresh();
  };

  watch([currentPage, perPage, searchQuery, statusFilter], () => {
    refetchData();
  });

  const fetchData = (ctx, callback) => {
    overlay.value = true;
    sLSUnidadeMedidaService.index({
      q: searchQuery.value,
      perPage: perPage.value,
      page: currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      fullObject: true,
    }).then((response) => {
      const { data, total } = response;
      overlay.value = false;
      callback(data);
      perPage.value = response.perPage;
      currentPage.value = response.page;
      totalItem.value = total;
    })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error ao carregar os dados',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
      });
  };

  const createOrUpdated = async (body) => {
    if (body.item_id) {
      await sLSUnidadeMedidaService.update(body.item_id, body);
    } else {
      await sLSUnidadeMedidaService.store(body);
    }
    refetchData();
  };

  const removerData = async (id) => {
    await sLSUnidadeMedidaService.destroy(id);
    refetchData();
  };

  return {
    fetchData,
    tableColumns,
    perPage,
    currentPage,
    totalItem,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    overlay,
    refUnidadeNegocioListTable,
    refetchData,
    createOrUpdated,
    statusFilter,
    removerData,
  };
}
